module.exports = __webpack_public_path__ + "img/resp-blog.9610d9ac.svg";